<p-dialog [visible]="watcherVisible()" [modal]="true" [draggable]="false" [resizable]="false"
    styleClass="watcher-dialog" [style]="{ width: 'min(520px, 92vw)' }" header="Add Shipment Watcher"
    (onHide)="command.emit({ type: 'close-watcher' })">
    <div class="watcher-dialog-body">
        <div class="watcher-dialog-copy">
            <strong>Watcher contact</strong>
            <span>Add an internal or party contact who should stay connected to this shipment.</span>
        </div>
        <p-select inputId="watcherContact" [options]="watcherOptions()" [ngModel]="selectedWatcher()"
            (ngModelChange)="command.emit({ type: 'select-watcher', contact: $event })" optionLabel="name"
            placeholder="Select contact" [filter]="true" filterBy="name,emailAddress,phoneNumber"
            [loading]="watcherLoading()" appendTo="body" styleClass="w-full">
            <ng-template pTemplate="selectedItem" let-contact><span>{{ contact?.name }}</span></ng-template>
            <ng-template pTemplate="item" let-contact>
                <div class="watcher-option">
                    <strong>{{ contact.name }}</strong>
                    <span>{{ contact.company?.name || contact.emailAddress || contact.phoneNumber || 'Contact' }}</span>
                </div>
            </ng-template>
        </p-select>
        @if (!watcherLoading() && watcherOptions().length === 0) {
        <div class="inline-empty">No available contacts found. Sender, receiver, and existing watchers are excluded.</div>
        }
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" [text]="true" (onClick)="command.emit({ type: 'close-watcher' })"
            [disabled]="watcherSaving()"></p-button>
        <p-button label="Add Watcher" icon="fa-solid fa-plus" severity="help" (onClick)="command.emit({ type: 'save-watcher' })"
            [loading]="watcherSaving()" [disabled]="!selectedWatcher()"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="Add Order Releases" [visible]="amendmentVisible()" [modal]="true" [draggable]="false"
    [resizable]="false" [style]="{ width: 'min(1440px, 96vw)', height: 'min(88vh, 960px)' }"
    [breakpoints]="{ '860px': '96vw' }" styleClass="release-amendment-dialog"
    (onHide)="command.emit({ type: 'close-amendment' })">
    <section class="release-amendment-layout">
        <aside class="release-amendment-summary">
            <div class="release-amendment-summary-icon"><i class="fa-solid fa-link"></i></div>
            <div>
                <small>{{ shipmentReleaseMode() ? 'Shipment planning' : 'Delivery amendment' }}</small>
                <h3>{{ shipmentReleaseMode() ? 'Add Order Releases' : 'Update delivery load' }}</h3>
                <p>{{ shipmentReleaseMode()
                    ? 'Link ready releases before delivery planning begins.'
                    : 'Review future route visits and price impact, including while the delivery is in transit.' }}</p>
            </div>
            <div class="release-amendment-facts">
                <div><span>{{ shipmentReleaseMode() ? 'Shipment' : 'Delivery' }}</span><strong>{{ shipmentReleaseMode() ? shipmentNumber() : amendmentDelivery()?.deliveryNumber }}</strong></div>
                <div><span>Selected releases</span><strong>{{ selectedReleaseIds().length }}</strong></div>
                <div><span>Current step</span><strong>{{ amendmentStep() }} of 3</strong></div>
            </div>
            <div class="release-amendment-summary-note">
                <i class="fa-solid fa-circle-info"></i>
                <span>{{ shipmentReleaseMode()
                    ? 'Route, capacity, and delivery execution are planned after driver and vehicle assignment.'
                    : 'Active stops stay unchanged. Vehicle and load concerns are shown in red; release and billing rules run again at Apply.' }}</span>
            </div>
        </aside>

        <section class="release-amendment-main">
    <div class="release-amendment-header">
        <div><span>{{ shipmentReleaseMode() ? 'Shipment planning' : 'Delivery amendment' }}</span><strong>{{ shipmentReleaseMode() ? shipmentNumber() : amendmentDelivery()?.deliveryNumber }}</strong></div>
        <ol class="release-amendment-steps" aria-label="Release attachment steps">
            <li [class.active]="amendmentStep() === 1" [class.complete]="amendmentStep() > 1">1. Select</li>
            <li [class.active]="amendmentStep() === 2" [class.complete]="amendmentStep() > 2">2. Review route</li>
            <li [class.active]="amendmentStep() === 3">3. Confirm</li>
        </ol>
    </div>
    @if (!shipmentReleaseMode() && !amendmentCanApply()) {
    <div class="release-danger-notice" role="alert"><i class="fa-solid fa-triangle-exclamation"></i><span>You can review this amendment, but delivery edit permission is required to apply it.</span></div>
    }

    <div class="release-amendment-scroll-area">
    @if (amendmentStep() === 1) {
    <section class="release-amendment-body">
        <div class="release-amendment-copy">
            <strong>Select ready order releases</strong>
            <span>All unassigned READY releases are shown. New waypoints and timing mismatches can be reviewed; red messages identify operational danger or a rule that will prevent Apply.</span>
        </div>
        <div class="release-candidate-search">
            <input class="p-inputtext" type="search" aria-label="Search order releases" placeholder="Search release, source or route"
                [ngModel]="releaseSearch()" (ngModelChange)="command.emit({ type: 'set-release-search', value: $event })"
                (keydown.enter)="command.emit({ type: 'search-releases' })">
            <p-button label="Search" icon="fa-solid fa-magnifying-glass" [outlined]="true"
                (onClick)="command.emit({ type: 'search-releases' })"></p-button>
        </div>
        @if (releasePoolError()) {
        <div class="inline-empty" role="alert">{{ releasePoolError() }}</div>
        }
        @if (!amendmentLoading()) {
        <div class="release-pool-list">
            @for (release of releasePool(); track release.releaseId) {
            <label class="release-pool-row" [class.selected]="releaseSelected(release.releaseId)">
                <input type="checkbox" [checked]="releaseSelected(release.releaseId)"
                    (change)="command.emit({ type: 'toggle-release', releaseId: release.releaseId })">
                <div><strong>{{ release.releaseNumber }}</strong><span>{{ release.sourceNumber || 'Order release' }}</span>
                    <span>{{ release.crmClientName || (release.crmClientId ? 'Client #' + release.crmClientId : release.partyKey) }}
                        @if (release.crmAccountId) { · {{ release.crmAccountName || 'Account #' + release.crmAccountId }} }</span></div>
                <div class="release-pool-route">
                    <span><i class="fa-solid fa-location-dot"></i> {{ release.originName || 'Pickup location' }}</span>
                    <span><i class="fa-solid fa-flag-checkered"></i> {{ release.destinationName || 'Drop-off location' }}</span>
                </div>
                <div class="release-candidate-tags">
                    <p-tag [value]="release.fitPercentage + '% fit'" [severity]="release.blockerReason || release.dangerWarnings?.length ? 'danger' : release.timingWarning ? 'warn' : 'success'"></p-tag>
                    @if (release.timingWarning) { <p-tag value="Timing mismatch" severity="warn"></p-tag> }
                    @if (release.requiresZeroSellConversion) { <p-tag value="Zero-sell conversion" severity="warn"></p-tag> }
                </div>
                @if (release.timingWarning) { <small class="release-candidate-warning">{{ release.timingWarning }}</small> }
                @if (release.blockerReason) { <small class="release-candidate-danger"><i class="fa-solid fa-circle-exclamation"></i> Cannot apply: {{ release.blockerReason }}</small> }
                @for (warning of release.dangerWarnings || []; track $index) { <small class="release-candidate-danger"><i class="fa-solid fa-triangle-exclamation"></i> {{ warning }}</small> }
            </label>
            }
            @if (releasePool().length === 0 && !releasePoolError()) {
            <div class="inline-empty">No unassigned READY releases match this search.</div>
            }
        </div>
        @if (releaseTotalPages() > 1) {
        <nav class="release-candidate-pages" aria-label="Order release pages">
            <span>{{ releaseTotal() }} matching releases · page {{ releasePage() + 1 }} of {{ releaseTotalPages() }}</span>
            <p-button label="Previous" [outlined]="true" [disabled]="releasePage() === 0"
                (onClick)="command.emit({ type: 'page-releases', page: releasePage() - 1 })"></p-button>
            <p-button label="Next" [outlined]="true" [disabled]="releasePage() + 1 >= releaseTotalPages()"
                (onClick)="command.emit({ type: 'page-releases', page: releasePage() + 1 })"></p-button>
        </nav>
        }
        } @else {
        <div class="inline-empty"><i class="pi pi-spin pi-spinner"></i> Loading Release Pool…</div>
        }
    </section>
    }

    @if (amendmentStep() === 2 && shipmentReleaseMode() && attachmentPreview(); as preview) {
    <section class="release-amendment-body">
        <div class="release-amendment-copy"><strong>Review combined route</strong>
            <span>Confirm the route and commercial effect before attaching these releases.</span></div>
        <div class="release-amendment-metrics">
            <div><span>Distance</span><strong>{{ preview.metrics?.distanceKm ?? 0 | number:'1.0-1' }} km</strong></div>
            <div><span>Duration</span><strong>{{ preview.metrics?.durationMinutes ?? 0 }} min</strong></div>
            <div><span>Weight</span><strong>{{ preview.metrics?.totalWeightKg ?? 0 | number:'1.0-2' }} kg</strong></div>
            <div><span>Selected</span><strong>{{ preview.releaseIds.length }} releases</strong></div>
        </div>
        @if (preview.timingWarning) {
        <div class="release-bayan-notice" role="alert"><i class="fa-solid fa-clock"></i><span>Timing mismatch: {{ preview.timingWarning }}. Review the route before continuing.</span></div>
        }
        <div class="release-route-preview">
            @for (stop of preview.route; track stop.sequence) {
            <div class="release-route-stop"><span class="release-route-sequence">{{ stop.sequence }}</span>
                <div><strong>{{ stop.locationName || 'Location pending' }}</strong><span>{{ stop.type }}</span></div></div>
            }
        </div>
        @if (preview.requiresZeroSellConversion) {
        <div class="release-bayan-notice" role="status">Confirming will convert this shipment to consolidated zero sell. Shipment selling amounts become zero; buying cost and source order prices stay unchanged.</div>
        }
    </section>
    }

    @if (amendmentStep() === 2 && amendmentPreview(); as preview) {
    <section class="release-amendment-body">
        <div class="release-amendment-copy">
            <strong>Optimized combined route</strong>
            <span>Pickup-before-drop-off precedence, the delivery's pending stops, and the selected release windows are included in this review.</span>
        </div>
        <div class="release-amendment-metrics">
            <div><span>Distance</span><strong>{{ preview.metrics?.distanceKm ?? 0 | number:'1.0-1' }} km</strong></div>
            <div><span>Duration</span><strong>{{ preview.metrics?.durationMinutes ?? 0 }} min</strong></div>
            <div><span>Weight</span><strong>{{ preview.metrics?.totalWeightKg ?? 0 | number:'1.0-2' }} kg</strong></div>
            <div><span>Pallets</span><strong>{{ preview.metrics?.totalPallets ?? 0 }}</strong></div>
        </div>
        @if (preview.timingWarning) {
        <div class="release-bayan-notice" role="alert"><i class="fa-solid fa-clock"></i><span>Timing mismatch: {{ preview.timingWarning }}. Review the route before continuing.</span></div>
        }
        @for (warning of preview.dangerWarnings || []; track $index) {
        <div class="release-danger-notice" role="alert"><i class="fa-solid fa-triangle-exclamation"></i><span>{{ warning }}. You may continue after reviewing this danger.</span></div>
        }
        <div class="release-route-preview">
            @for (stop of preview.route; track stop.sequence) {
            <div class="release-route-stop">
                <span class="release-route-sequence">{{ stop.sequence }}</span>
                <i [class]="stop.type === 'PICKUP' ? 'fa-solid fa-arrow-up-from-bracket' : 'fa-solid fa-arrow-down-to-bracket'"></i>
                <div><strong>{{ stop.locationName || 'Location pending' }}</strong><span>{{ stop.type }}{{ stop.releaseNumber ? ' · ' + stop.releaseNumber : '' }}</span></div>
                <small *ngIf="stop.plannedArrival">{{ stop.plannedArrival | date:'dd-MM-yyyy HH:mm' }}</small>
            </div>
            }
        </div>
        <div class="release-price-review">
            <div><span>Current buying</span><strong>{{ preview.prices?.currentBuyingPrice ?? 0 | number:'1.2-2' }}</strong></div>
            <div><span>Current selling</span><strong>{{ preview.prices?.currentSellingPrice ?? 0 | number:'1.2-2' }}</strong></div>
            <div><span>Proposed buying</span><strong>{{ preview.prices?.proposedBuyingPrice ?? 0 | number:'1.2-2' }}</strong></div>
            <div><span>Proposed selling</span><strong>{{ preview.prices?.proposedSellingPrice ?? 0 | number:'1.2-2' }}</strong></div>
        </div>
        @if (preview.requiresZeroSellConversion) {
        <div class="release-bayan-notice" role="status">This amendment converts the shipment to consolidated zero sell. Confirmed selling must be zero; buying cost and source order prices stay unchanged.</div>
        }
    </section>
    }

    @if (amendmentStep() === 3 && shipmentReleaseMode() && attachmentPreview(); as preview) {
    <section class="release-amendment-body">
        <strong>Confirm {{ preview.releaseIds.length }} order release(s)</strong>
        @if (preview.timingWarning) {
        <div class="release-bayan-notice" role="alert">Timing mismatch: {{ preview.timingWarning }}. Confirm only if this schedule is acceptable.</div>
        }
        @if (preview.requiresZeroSellConversion) {
        <div class="release-bayan-notice" role="status">I confirm converting this shipment to consolidated zero sell. Its selling amount will be zero.</div>
        }
    </section>
    }

    @if (amendmentStep() === 3 && amendmentPreview(); as preview) {
    <section class="release-amendment-body">
        <div class="release-amendment-copy">
            <strong>Confirm the amendment</strong>
            <span>The approved delivery prices change only this shipment and delivery. Source sales-order prices remain unchanged.</span>
        </div>
        @if (preview.timingWarning) {
        <div class="release-bayan-notice" role="alert">Timing mismatch: {{ preview.timingWarning }}. Confirm only if this schedule is acceptable.</div>
        }
        @for (warning of preview.dangerWarnings || []; track $index) {
        <div class="release-danger-notice" role="alert"><i class="fa-solid fa-triangle-exclamation"></i><span>{{ warning }}</span></div>
        }
        <div class="release-amendment-confirm-grid">
            <label><span>Revised buying price *</span><input type="number" min="0" step="0.01" class="p-inputtext w-full"
                [ngModel]="amendmentBuyingPrice()" (ngModelChange)="command.emit({ type: 'set-amendment-buying-price', value: $event })"></label>
            <label><span>Revised selling price *</span><input type="number" min="0" step="0.01" class="p-inputtext w-full"
                [ngModel]="amendmentSellingPrice()" [disabled]="preview.requiresZeroSellConversion || zeroSellShipment()"
                (ngModelChange)="command.emit({ type: 'set-amendment-selling-price', value: $event })"></label>
            <label class="release-amendment-reason"><span>Amendment reason *</span><textarea rows="4" class="p-inputtext p-inputtextarea w-full"
                [ngModel]="amendmentReason()" (ngModelChange)="command.emit({ type: 'set-amendment-reason', value: $event })"
                placeholder="Explain why these releases are being added."></textarea></label>
        </div>
        @if (preview.previousGovtWaybillId) {
        <div class="release-bayan-notice"><i class="fa-solid fa-file-shield"></i><span>The existing Bayan waybill will be cancelled and replaced before the driver receives the refreshed route. If replacement fails, pickup stays blocked until portal reconciliation succeeds.</span></div>
        }
    </section>
    }

    @if (amendmentHistory().length > 0) {
    <section class="release-amendment-history">
        <strong>Amendment history</strong>
        @for (item of amendmentHistory(); track item.amendmentId) {
        <div class="release-amendment-history-row">
            <span>#{{ item.amendmentId }} · {{ item.releaseIds?.length || 0 }} releases</span>
            <p-tag [value]="item.status" [severity]="item.status === 'COMPLETED' ? 'success' : item.status === 'COMPLIANCE_PENDING' ? 'warn' : 'secondary'"></p-tag>
            @if (item.status === 'COMPLIANCE_PENDING' && amendmentCanApply()) {
            <button pButton type="button" label="Retry Bayan" size="small" severity="warn" [outlined]="true"
                [loading]="amendmentApplying()" (click)="command.emit({ type: 'retry-bayan', amendment: item })"></button>
            }
        </div>
        }
    </section>
    }
    </div>
        </section>
    </section>

    <ng-template pTemplate="footer">
        <div class="release-amendment-footer">
        <p-button label="Cancel" severity="secondary" [outlined]="true" (onClick)="command.emit({ type: 'close-amendment' })" [disabled]="amendmentApplying()"></p-button>
        <span class="footer-spacer"></span>
        @if (amendmentStep() === 1) {
        <p-button [label]="shipmentReleaseMode() ? 'Review attachment' : 'Preview optimized route'" icon="fa-solid fa-route" (onClick)="command.emit(shipmentReleaseMode() ? { type: 'attach-releases-to-shipment' } : { type: 'preview-amendment' })"
            [loading]="amendmentLoading()" [disabled]="selectedReleaseIds().length === 0"></p-button>
        }
        @if (amendmentStep() === 2) {
        <p-button label="Back" severity="secondary" [outlined]="true" (onClick)="command.emit({ type: 'set-amendment-step', step: 1 })"></p-button>
        <p-button [label]="shipmentReleaseMode() ? 'Continue to confirmation' : 'Confirm prices'" icon="fa-solid fa-arrow-right" (onClick)="command.emit({ type: 'confirm-amendment-prices' })"></p-button>
        }
        @if (amendmentStep() === 3) {
        <p-button label="Back" severity="secondary" [outlined]="true" (onClick)="command.emit({ type: 'set-amendment-step', step: 2 })"></p-button>
        <p-button [label]="shipmentReleaseMode() ? 'Confirm and attach' : 'Apply amendment'" icon="fa-solid fa-check" severity="success"
            (onClick)="command.emit(shipmentReleaseMode() ? { type: 'apply-shipment-attachment' } : { type: 'apply-amendment' })"
            [loading]="amendmentApplying()" [disabled]="!shipmentReleaseMode() && (!amendmentCanApply() || !amendmentReason().trim() || amendmentBuyingPrice() == null || amendmentSellingPrice() == null)"></p-button>
        }
        </div>
    </ng-template>
</p-dialog>

<p-dialog header="Cancel Delivery" [visible]="cancellationVisible()" [modal]="true" [draggable]="false" [resizable]="false"
    [style]="{ width: 'min(560px, 94vw)' }" (onHide)="command.emit({ type: 'close-cancellation' })">
    <div class="watcher-dialog-body">
        <div class="watcher-dialog-copy">
            <strong>{{ cancellationDelivery()?.deliveryNumber }}</strong>
            <span>This dispatch job will be retained in the audit trail and will no longer count toward shipment fulfilment.</span>
        </div>
        <label class="w-full"><span class="field-label">Cancellation reason *</span>
            <textarea rows="5" class="p-inputtext p-inputtextarea w-full" [ngModel]="cancellationReason()"
                (ngModelChange)="command.emit({ type: 'set-cancellation-reason', value: $event })"
                placeholder="Explain why this delivery is being cancelled."></textarea>
        </label>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Keep Delivery" severity="secondary" [text]="true" (onClick)="command.emit({ type: 'close-cancellation' })"
            [disabled]="cancellationSaving()"></p-button>
        <p-button label="Cancel Delivery" icon="fa-solid fa-ban" severity="danger" (onClick)="command.emit({ type: 'confirm-cancellation' })"
            [loading]="cancellationSaving()" [disabled]="!cancellationReason().trim()"></p-button>
    </ng-template>
</p-dialog>
